<template>
  <div :class="$style.wrap">
    <NameAllot :branch="branch" v-if="type === '2'" />
    <DepartmentAllot v-if="type === '0'" type="0" :branch="branch" />
  </div>
</template>

<script>
import { getAllotModel } from "@/modules/allotModel";
import NameAllot from "./NameAllot";
import DepartmentAllot from "./DepartmentAllot";
export default {
  name: "AllotModelComp",
  components: {
    NameAllot,
    DepartmentAllot,
  },
  props: {
    branch: {
      type: Object,
    },
  },
  data() {
    return {
      type: "",
    };
  },
  mounted() {
    this.getModel();
  },
  methods: {
    async getModel() {
      const req = await getAllotModel({
        branch: this.branch.id,
      });
      const { code, data } = await req.json();
      if (code === 200) {
        this.type = data.allocation_type?.value;
      }
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  padding: 20px;
  padding-top: 0;
}
.title {
  display: flex;
}
</style>
